import gql from "graphql-tag";

export const MY_LEAVE_GET_IS_EXAMINER_CONTRACT = gql`
  query isExaminerContract($contract: String!) {
    isExaminerContract(contract: $contract)
  }
`;
